import { NEW_KITCHEN_CDN_PATH } from '../../new-kitchen-constants';
import { Delivery, Done, Guarantee, Project } from './components';

export type HeaderCardStructure = {
  name: string;
  text: string;
  icon: {
    src: string;
    alt: string;
  };
  modal: React.FC<{ onCloseModal: () => void; signUpHref: string }>;
};

export const HEADER_CARD_LIST: HeaderCardStructure[] = [
  {
    text: 'Сделаем бесплатный дизайн проект',
    icon: {
      src: `${NEW_KITCHEN_CDN_PATH}/header/project.png/project.png`,
      alt: 'Бесплатный дизайн проект',
    },
    name: 'free-project',
    modal: Project,
  },
  {
    text: 'Через 10\u00A0дней кухня у\u00A0вас дома',
    icon: {
      src: `${NEW_KITCHEN_CDN_PATH}/header/delivery.png/delivery1.png`,
      alt: 'Изготовление за 10 дней',
    },
    name: 'delivery',
    modal: Delivery,
  },
  {
    text: 'Гарантия 25 лет на\u00A0все изделия*',
    icon: {
      src: `${NEW_KITCHEN_CDN_PATH}/header/guarantee.png/guarantee1.png`,
      alt: 'Гарантия 25 лет',
    },
    name: 'guarantee',
    modal: Guarantee,
  },
  {
    text: 'Более 1 млн\nготовых кухонь',
    icon: {
      src: `${NEW_KITCHEN_CDN_PATH}/header/done.png/done1.png`,
      alt: 'Реализованные проекты',
    },
    name: 'projects',
    modal: Done,
  },
];
